module.exports = __webpack_public_path__ + "img/btn_user.9638d209.svg";